const STORAGE_UUID_PREFIX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}_)+/i;

export const getTrainingDocumentFileName = (document) => {
    if (!document) return '';
    const fileName = document.fileName.split(/[\\/]/).pop();
    return fileName.replace(STORAGE_UUID_PREFIX, '');
};
